import './index.css';
// ============================================================
// packages/web/src/main.tsx
// React entry point. Order matters:
//   1. index.css  must be first — initialises Tailwind before
//      any component renders so there is no flash of unstyled
//      content (FOUC).
//   2. AuthProvider wraps the entire tree so every page/hook
//      can call useAuth() without a null-check.
// ============================================================

import './index.css';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';

const container = document.getElementById('root');

if (!container) {
  throw new Error(
    '[main.tsx] Could not find #root element. ' +
    'Make sure index.html contains <div id="root"></div>.',
  );
}

createRoot(container).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);

// Hide the pre-React loading screen (defined in index.html)
const loader = document.getElementById('app-loader');
if (loader) {
  loader.classList.add('hidden');
  // Remove from DOM after the CSS transition completes
  setTimeout(() => loader.remove(), 400);
}